<template>
	<modal :show.sync="showAccountModal" effect="custom" class="account-selection-modal">
		<div slot="modal-header" class="modal-header center">
			<h4 class="modal-title">Please Select Your Account</h4>
		</div>
		<div slot="modal-body" class="modal-body center">
			<div class="mt-element-card mt-card-round mt-element-overlay">
				<div class="col-md-4" v-for="account in userAccounts">
					<div class="mt-card-item" :class="{'selected': selectedAccountId === account.account_id}">
						<div class="mt-card-avatar mt-overlay-1">
                            <img src="../../metronic_src/theme/assets/pages/media/profile/avatar.png">
                        </div>
                        <div class="mt-card-content">
                            <h3 class="mt-card-name">{{ account.business_name }}</h3>
                            <p class="mt-card-desc font-grey-mint" v-if="account.role === 'system_admin'">System Admin</p>
                            <p class="mt-card-desc font-grey-mint" v-else-if="account.role === 'super_admin'">Super Admin</p>
                            <p class="mt-card-desc font-grey-mint" v-else-if="account.role === 'staff'">Staff</p>
                            <div class="mt-card-social">
                                <ul>
                                    <li>
                                        <button type="button" class="btn btn-success" @click="selectAccount(account.account_id)">Select</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
					</div>
				</div>
			</div>
		</div>
		<div slot="modal-footer" class="modal-footer">
			<button type="button" class="btn btn-primary" @click="loginToSelectedAccount($event)" :disabled="!selectedAccountId">Let's Begin</button>
		</div>
	</modal>
</template>

<script>
import $ from 'jquery'
import Modal from './modules/Modal'
import Account from '../controllers/Account'
import Auth from '../controllers/Auth'
import GlobalFunctions from '../global'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'select-account',
	data () {
		return {
			showAccountModal: false,
			activeAccount: {},
			selectedAccountId: '',
			errorMessage: '',
			routeMessage: ''
		}
	},
	created () {
		// if the user navigated to this page and the list of accounts hasn't been saved in the global variable then do it now
		if (this.activeUser && !this.userAccountsLength) {
			this.getUserAccounts()
		}
	},
	mounted () {
		this.showAccountModal = true
	},
	computed: mapGetters([
		'activeUser',
		'userAccountsLength',
		'userAccounts'
	]),
	methods: {
		/**
		 * To highlight the account that the user selected.
		 * @function
		 * @param {number} accountId - The id of the account selected by the user.
		 * @returns {undefined}
		 */
		selectAccount (accountId) {
			if (this.selectedAccountId !== accountId) {
				this.selectedAccountId = accountId
			}
		},
		/**
		 * To login to the selected user account
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 */
		loginToSelectedAccount (event) {
			if (this.selectedAccountId) {
				let _this = this
				let disabledButton = GlobalFunctions.disableButton(event)

				Auth.loginToAccount(this.selectedAccountId).then(response => {
					_this.setV3Token(response.payload.token)

					_this.getSelectedAccountDetails()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						$('body').removeClass('app-body')
						switch (e.responseJSON.declaration) {
						case 'invalid_account':
							_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.'
							_this.$router.message = _this.routeMessage
							_this.$router.push({path: '/error', props: {message: _this.routeMessage}})
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			} else {
				return
			}
		},
		/**
		 * To get the details of the selected user account and send/emit these details to the parent.
		 * @function
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 */
		getSelectedAccountDetails () {
			let _this = this

			Account.getCurrentAccountDetails().then(response => {
				_this.setActiveAccount(response.payload)
				_this.setActiveBusinessName(response.payload.business_name)
				_this.$router.push('dashboard')
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					$('body').removeClass('app-body')
					switch (e.responseJSON.declaration) {
					case 'account_not_found':
						_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.'
						_this.$router.message = _this.routeMessage
						_this.$router.push({path: '/error', props: {message: _this.routeMessage}})
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To get the list of accounts that are associated to the current user.
		 * @function
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 */
		getUserAccounts () {
			let _this = this

			Account.getUserAccounts().then(response => {
				_this.setActiveUserAccounts(response.payload.accounts)
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					$('body').removeClass('app-body')
					switch (e.responseJSON.declaration) {
					case 'no_accounts_found':
						_this.routeMessage = 'We were unable to find any accounts linked to your email. Please contact your admin.'
						_this.$router.message = _this.routeMessage
						_this.$router.push({path: '/error', props: {message: _this.routeMessage}})
						break

					default:
						// No default
					}
				}
			}))
		},
		...mapActions([
			'setActiveUserAccounts',
			'setActiveAccount',
			'setActiveBusinessName',
			'setV3Token'
		])
	},
	components: {
		Modal
	}
}
</script>

<style>
.center {
	text-align: center;
}
.modal-body {
	max-height: 500px;
    overflow: auto;
}
.modal-body .mt-element-card.mt-card-round .mt-card-item {
	background-color: #eee;
	padding: 20px 20px 10px;
	min-height: 265px;
}
.modal-body .mt-element-card.mt-card-round .mt-card-item.selected {
	border: 2px solid #2bb8c4;
}
.modal-body .mt-element-overlay .mt-overlay-1 {
	width: 55%;
	float: none;
}
.modal-body .mt-element-card .mt-card-item .mt-card-avatar{
	margin: 0 auto;
}
.modal-body .mt-element-card .mt-card-item .mt-card-content .mt-card-name {
	margin: 10px 0px;
	white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.modal-body .mt-element-card .mt-card-item .mt-card-content .mt-card-desc {
	margin: 0 0 5px;
}
.modal.account-selection-modal .modal-content .modal-footer {
	border-top: 1px solid #EFEFEF;
}
@media (min-width: 768px) {
	.modal.account-selection-modal .modal-dialog {
		width: 800px;
    	margin: 30px auto;
	}
}
</style>


// WEBPACK FOOTER //
// SelectAccount.vue?5bbe1c87